import * as React from 'react';

function SvgRejectedNoShadow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19" {...props}>
      <g fill="#D21E1F" fillRule="evenodd">
        <path
          d="M8.139 0h-.403L.405 2.601l-.033.016A.669.669 0 000 3.22v7.475c.018.644.343 1.754 1.067 2.922 1.214 1.942 3.355 3.728 6.629 5.091l.236.099.236-.099c3.182-1.32 5.31-3.041 6.564-4.981a7.8 7.8 0 00.952-2.037c.123-.418.178-.755.19-.978V3.22c0-.27-.147-.49-.372-.602l-.033-.016L8.14 0zm-.202 1.234l6.706 2.38.001 7.032a1.965 1.965 0 01-.023.19c-.025.149-.063.319-.118.507a6.575 6.575 0 01-.805 1.714l-.056.087c-1.086 1.633-2.909 3.116-5.653 4.303l-.057.024-.05-.022c-2.877-1.247-4.728-2.817-5.77-4.483l-.048-.08c-.573-.947-.822-1.809-.833-2.21V3.614l6.706-2.38z"
          fillRule="nonzero"
        />
        <path d="M4.888 5.963a.68.68 0 01.961 0l1.924 1.923 1.924-1.923a.68.68 0 01.962.962L8.735 8.848l1.924 1.924a.68.68 0 01-.962.962L7.773 9.811l-1.924 1.923a.68.68 0 01-.961-.962L6.81 8.848 4.888 6.925a.68.68 0 010-.962z" />
      </g>
    </svg>
  );
}

export default SvgRejectedNoShadow;
